export default function computeUsageChartData({
  dataByUser,
  periods,
  users,
  features,
  selectedUser,
  selectedFeature,
  selectedPageView
}) {
  // determine which features to include
  const filteredFeatures = (() => {
    if (selectedFeature === 'all') {
      return features
    }
    if (selectedFeature === 'Page View') {
      const pageViews = features.filter(f => f.startsWith('Page View -')).filter(f => f !== 'Page View - All')
      
      return selectedPageView === 'all'
        ? pageViews
        : [selectedPageView]
    }
    return [selectedFeature]
  })()

  return periods.map(period => {
    const row = { period }
    users.forEach(user => {
      if (selectedUser !== 'all' && user !== selectedUser) return
      const series = dataByUser[user] || []
      const entry = series.find(r => r.period === period) || {}

      filteredFeatures.forEach(feature => {
        row[feature] = (row[feature] || 0) + (entry[feature] || 0)
      })
    })

    return row
  })
}